const isSafariBrowser = () => {
  const userAgent = window.navigator.userAgent;
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
  return isSafari;
};

/**
 * Detect Firefox (desktop, Android, and iOS).
 *
 * Desktop/Android Firefox user agents contain "Firefox"; on iOS Firefox is a
 * WebKit wrapper and reports "FxiOS" instead. Matching either covers every
 * Firefox variant without misfiring on Chrome/Safari/Edge, none of which
 * include those tokens.
 *
 * TODO(MUS-278): this is a temporary block while Firefox bugs are fixed.
 * Remove this helper (and its usage in DeviceCompatibilityBlockingScreen) once
 * Firefox is supported again.
 */
const isFirefoxBrowser = (userAgent: string = window.navigator.userAgent): boolean =>
  /Firefox|FxiOS/i.test(userAgent);

const isMobileBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor;
  const touch = navigator.maxTouchPoints || 0;
  const uaMatch =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(userAgent);
  // iPadOS 13+ reports as Macintosh but has touch points
  const isModernIPad = /Macintosh/i.test(userAgent) && touch > 1;
  return uaMatch || isModernIPad;
};

export const isIosTablet = () => {
  const userAgent = navigator.userAgent || navigator.vendor;
  return /webOS|iPhone|iPad|iPod/.test(userAgent);
};

const isCompatibleAndroid = () => {
  const userAgent = navigator.userAgent || navigator.vendor;

  return (
    (/Android|android/i.test(userAgent) ||
      /Opera|opera/i.test(userAgent) ||
      /baidu|Baidu/i.test(userAgent) ||
      /qq|QQ|Qq/i.test(userAgent)) &&
    (!/Opera Mini/i.test(userAgent) || !/Firefox|firefox/i.test(userAgent))
  );
};

/**
 * Runtime touch-capability check — orientation- and screen-size-independent.
 *
 * Unlike the `mobile` small-screen flag (a max-width media query), this stays
 * true for an iPad in landscape (where the viewport is wide enough that `mobile`
 * is false) and is emulated correctly by browser device toolbars. Use it to gate
 * touch-only gestures like tap/double-tap-to-play, which should key off "does
 * this device use touch", not "is the screen narrow".
 */
const isTouchDevice = () =>
  (navigator.maxTouchPoints ?? 0) > 0 ||
  (typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches);

export { isSafariBrowser, isFirefoxBrowser, isMobileBrowser, isCompatibleAndroid, isTouchDevice };
